import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {LocationSearchModel} from "../location-search.model";
import {LocationSearchPageComponent} from "../location-search-page/location-search-page.component";
import {LocationEditPageComponent} from "../location-edit-page/location-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-location-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(LocationSingleSelectEditControlComponent),
        provideSearchModel(LocationSearchModel)
    ]
})
export class LocationSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<LocationSearchModel> {
    constructor(model: LocationSearchModel, injector: Injector) {
        super(model, injector, "outletGroupId", "groupName");

        this.extendedSearchComponent = LocationSearchPageComponent;
        this.extendedEditComponent = LocationEditPageComponent;
    }
}
